"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getOctetArray(ipaddress) {
    return ipaddress.split('.');
}
exports.getOctetArray = getOctetArray;
function getOctet(ipaddress, octet) {
    return getOctetArray(ipaddress)[octet - 1];
}
exports.getOctet = getOctet;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2V0T2N0ZXRBcnJheS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkdldE9jdGV0QXJyYXkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx1QkFBK0IsU0FBaUI7SUFDOUMsTUFBTSxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUE7QUFDN0IsQ0FBQztBQUZELHNDQUVDO0FBRUQsa0JBQTBCLFNBQWlCLEVBQUUsS0FBYTtJQUN4RCxNQUFNLENBQUMsYUFBYSxDQUFDLFNBQVMsQ0FBQyxDQUFDLEtBQUssR0FBRyxDQUFDLENBQUMsQ0FBQTtBQUM1QyxDQUFDO0FBRkQsNEJBRUMifQ==


//////////////////
// WEBPACK FOOTER
// ./src/GetOctetArray.ts
// module id = 5
// module chunks = 0